export default __webpack_public_path__ + "static/media/19.5f250d8e.webp";